import { useNavigate } from 'react-router-dom'
import Card from '../../public/components/Card'
import clsx from 'clsx'
import EditableListPage from '../components/EditableListPage'
import { Button } from '../../shared/components/Button'
import { FaGripLines, FaPen } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'

const NewsAdmin = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    const renderCard = item => (
        <Card
            key={item.id}
            imageSrc={item.header_image}
            buttonLabel={t('status.details')}
            onButtonClick={() => navigate(`/admin/auth/news/${item.id}`)}
        >
            <span
                className={clsx(
                    'inline-block px-3 py-1 text-xs font-medium rounded-full',
                    item.is_active === '1'
                        ? 'text-green-800 bg-green-200'
                        : 'text-red-800 bg-red-200'
                )}
            >
                {item.is_active === '1' ? t('status.active') : t('status.inactive')}
            </span>
            <span
                className={clsx(
                    'ml-2 inline-block px-3 py-1 text-xs font-medium rounded-full',
                    item.is_quick_donation === '1' && 'text-amber-800 bg-amber-200'
                )}
            >
                {item.is_quick_donation === '1' && t('status.quick_donation')}
            </span>
            <h3>{item.title}</h3>
            <span className='text-sm text-gray-500'>{item.subtitle}</span>
            <p>{item.urgency_message}</p>
        </Card>
    )

    return (
        <EditableListPage
            title={t('navigation_admin.news.main')}
            endpoint='admin/news'
            renderCard={renderCard}
            buttons={
                <>
                    <Button
                        variant='secondary'
                        size='medium'
                        onClick={() => navigate('/admin/auth/news/reorder')}
                    >
                        <FaGripLines /> {t('status.reorder')}
                    </Button>
                    <Button size='medium' onClick={() => navigate('/admin/auth/news/create')}>
                        <FaPen /> {t('status.create')}
                    </Button>
                </>
            }
        />
    )
}

export default NewsAdmin
